export const getJobs = `query jobs(
  $limit: Int!
  $page: Int!
  $name: String
  $searchText: String
  $isVerified: Boolean
) {
  jobs(
    limit: $limit
    page: $page
    where: {
      name: $name
      searchText: $searchText
      isVerified: $isVerified
    }
  ) {
    jobs {
      id
      name
      isVerified
      address
      branch {
        id
        name
      }
      users {
        id
      }
    }
    count
  }
}`
export const getUsers = `query users(
  $airedJobListings: Boolean
  $limit: Int
  $page: Int
  $businessArea: AreaWhereInput
  $businessAuthority: AuthorityWhereInput
  $email: String
  $searchText: String
  $isArchived: Boolean
  $isApproved: Boolean
  $roles: [Role]
  $isInFocusGroup: Boolean
  $closestArea: AreaWhereInput
  $authority: AuthorityWhereInput
  $createdAtGte: DateTime
  $lastActivityGte: DateTime
  $lastShiftLogGte: DateTime
  $birthdayLte: DateTime
  $birthdayGt: DateTime
) {
  users(
    limit: $limit
    page: $page
    where: {
      airedJobListings: $airedJobListings
      email: $email
      searchText: $searchText
      isInFocusGroup: $isInFocusGroup
      authority: $authority
      business: {
        isApproved: $isApproved
        area: $businessArea
        authority: $businessAuthority
      }
      closestArea: $closestArea
      createdAtGte: $createdAtGte
      lastActivityGte: $lastActivityGte
      lastShiftLogGte: $lastShiftLogGte
      birthdayLte: $birthdayLte
      birthdayGt: $birthdayGt
    }
    isArchived: $isArchived
    roles: $roles
  ) {
    users {
      id
      address
      birthday
      createdAt
      lastActivity
      business {
        id
        name
        createdAt
        isApproved
        businessNumber
        certificateImage
        address
        jobListings {
          id
          name
          createdAt
          expiresAt
          isBlocked
        }
        branch {
          id
          name
        }
        area {
          id
          name
        }
        authority {
          id
          name
        }
      }
      jobs {
        id
        start
        dailyTravelRefund
        monthlyBonuses
        monthlyExpenses
        job {
          name
        }
      }
      closestArea {
        id
        name
        isArchived
      }
      authority {
        id
        name
        isActive
        isArchived
      }
      email
      firstName
      image
      isArchived
      isConfirmed
      lastName
      phone
      role
      hasActiveJobListing
      mostRecentJobListing
    }
    count
  }
}`
export const getBranches = `query branches($limit: Int, $page: Int, $name: String, $isArchived: Boolean) {
  branches(limit: $limit, page: $page, where: { name: $name }, isArchived: $isArchived) {
    branches {
      id
      name
      image
      jobs {
        id
        name
      }
    }
    count
  }
}`
export const getJobListings = `query jobListings(
  $limit: Int
  $page: Int
  $name: String
  $airsAtGT: DateTime
  $airsAtLTE: DateTime
  $plans: [JobListingPlan]
  $area: AreaWhereInput
  $authority: AuthorityWhereInput
  $expiresAtGTE: DateTime
  $expiresAtLT: DateTime
  $isBlocked: Boolean
  $onlyReported: Boolean
  $onlyActive: Boolean
  $searchText: String
  $approvalStatus: ApprovalStatus
) {
  jobListings(
    limit: $limit
    page: $page
    where: {
      name: $name
      airsAt_gt: $airsAtGT
      airsAt_lte: $airsAtLTE
      area: $area
      plan: $plans
      authority: $authority
      expiresAt_gte: $expiresAtGTE
      expiresAt_lt: $expiresAtLT
      onlyReported: $onlyReported
      onlyActive: $onlyActive
      searchText: $searchText
      approvalStatus: $approvalStatus
    },
    isBlocked: $isBlocked
  ) {
    jobListings {
      airsAt
      allowEmailNotifications
      area {
        id
        name
      }
      authority {
        id
        name
      }
      business {
        id
        isApproved
        owner {
          id
          email
          firstName
          lastName
        }
      }
      branch {
        id
        name
      }
      createdAt
      description
      endTime
      expiresAt
      hourlyRate
      id
      image
      isAccessibleForTheDisabled
      isBlocked
      isBreaks
      isInShifts
      isOnSaturday
      isOvertime
      isPaidTraining
      isPublicTransportationAccessible
      isSalaryRaisable
      isShuttles
      isTips
      isTravelsRefunded
      workplace
      addresses
      jobsAmount
      jobsMannedAmount
      logoImage
      minimumAge
      name
      notes
      phone
      reports {
        id
        createdAt
        text
        user {
          email
        }
      }
      requirements
      salaryType
      startTime
      whatsapp
      weeklyWorkDays
      firstApplicationAt
      totalApplications
      totalWhatsappApplications
      totalPhoneApplications
      uniqueApplications
      plan
      isAcceptingInAppApplications
    }
    count
  }
}`
export const getRuleEngineAlgorithms = `query algorithms($isActive: Boolean) {
  ruleEngineAlgorithms(isActive: $isActive) {
    id
    code
    isActive
    isCoded
    name
    trigger
    rules {
      eventType
      eventParam
      topCondition {
        fact {
          id
        }
        operator {
          id
        }
        type
        compareValue
        children {
          fact {
            id
          }
          operator {
            id
          }
          type
          compareValue
          children {
            fact {
              id
            }
            operator {
              id
            }
            type
            compareValue
            children {
              fact {
                id
              }
              operator {
                id
              }
              type
              compareValue
            }
          }
        }
      }
    }
  }
}`

export const getRuleEngineBlocks = `query ruleEngineBlocks {
  ruleEngineBlocks {
    facts {
      name
      type
      value
      id
      createdAt
    }
    operators {
      id
      createdAt
      for
      name
      predicate
    }
  }
}`

export const getArticles = `query articles($limit: Int, $page: Int, $title: String, $isArchived: Boolean, $targetAudience: TargetAudience) {
  articles(limit: $limit, page: $page, where: { title: $title, targetAudience: $targetAudience }, isArchived: $isArchived) {
    count
    articles {
      id
      createdAt
      targetAudience
      title
      subtitle
      text
      image
      author {
        email
      }
      tags
    }
  }
}`

export const getConfigurations = `query configurations {
  configurations {
    id
    key
    value
  }
}`

export const isEmailAvailable = `query isEmailAvailable($email: String!) {
  isEmailAvailable(email: $email)
}`

export const isPhoneAvailable = `query isPhoneAvailable($phone: String!) {
  isPhoneAvailable(phone: $phone)
}`

export const uploadUrl = 'query { uploadUrl }'

export const getUserData = `query user($id: ID!, $jobId: ID) {
  user(id: $id) {
    id
    address
    firstName
    lastName
    email
    phone
    jobs(id: $jobId) {
        id
        start
        address
        dailyTravelRefund
        monthlyBonuses
        monthlyExpenses
        shifts {
          start
          end
        }
        paychecks {
          payments {
            totalPay
            unitAmount
            unitPrice
            title
          }
          month
        }
        job {
          name
        }
    }
  }
}`

export const getAreas = `query areas(
  $limit: Int
  $page: Int
  $isArchived: Boolean
  $orderBy: AreaOrderByInput
) {
  areas(
    limit: $limit
    page: $page
    isArchived: $isArchived
    orderBy: $orderBy
  ) {
    count
    areas {
      id
      activeYouthCount
      approvedBusinessesCount
      availableYouthCount
      hourLoggingYouthCount
      jobListingsCount
      location {
        lat
        lng
        address
      }
      name
      new30DaysBusinessesCount
      new30DaysYouthCount
      notes
      relevantBusinessesCount
      relevantYouthCount
      vacantPositionsCount
      lessThanFourteenYouthCount
      fourteenFifteenYouthCount
      sixteenYouthCount
      seventeenYouthCount
      eighteenYouthCount
      emailNotificationRadius
      nineteenTwentyYouthCount
      twentyOneTwentyFiveYouthCount
      overTwentySixYouthCount
    }
  }
}`

export const getAreasBasic = `query areas(
  $limit: Int
  $page: Int
  $isArchived: Boolean
  $orderBy: AreaOrderByInput
) {
  areas(
    limit: $limit
    page: $page
    isArchived: $isArchived
    orderBy: $orderBy
  ) {
    count
    areas {
      id
      name
    }
  }
}`

export const getAuthorities = `query authorities(
  $limit: Int
  $page: Int
  $isArchived: Boolean
  $isActive: Boolean
) {
  authorities(
    limit: $limit
    page: $page
    isArchived: $isArchived
    isActive: $isActive
  ) {
    count
    authorities {
      id
      createdAt
      isArchived
      activeYouthCount
      approvedBusinessesCount
      availableYouthCount
      gmapsLocalityId
      gmapsName
      hourLoggingYouthCount
      jobListingsCount
      logo
      leadArticle {
        id
        createdAt
        title
        subtitle
        text
        image
        author{
          id
          email
          firstName
          lastName
        }
        tags
        isArchived
        likes {
          id
          firstName
          lastName
        }
      }
      mayor
      mayorPic
      message
      name
      new30DaysBusinessesCount
      new30DaysYouthCount
      notes
      relevantBusinessesCount
      relevantYouthCount
      usersCount
      vacantPositionsCount
    }
  }
}`

export const getAuthoritiesBasic = `query authorities(
  $limit: Int
  $page: Int
  $isArchived: Boolean
) {
  authorities(
    limit: $limit
    page: $page
    isArchived: $isArchived
  ) {
    count
    authorities {
      id
      name
    }
  }
}`

export const getJobApplications = `query jobApplications($jobListingId: ID!) {
  jobApplications(where: { jobListingId: $jobListingId }) {
    id
    createdAt
    type
    user {
      firstName
      lastName
      phone
      birthday
      createdAt
      closestArea {
        name
      }
      authority {
        name
      }
    }
    jobListing {
      id
      airsAt
    }
  }
}`

export const getJobListingConfiguration = `query jobListingPlanConfigurations {
  jobListingPlanConfigurations {
   id
   plan
   title
   description
   price
   publishDuration
   applicationAmount
   featuresTitle
   features {
     id
     text
     toolTipText
   }
   publishButton
 }
}
`
